import { withInstall } from '@/utils'
import CosRangePicker from './src/cosRangePicker.vue'
export default withInstall(CosRangePicker)
